import { render, staticRenderFns } from "./ChecklistCleaningForm.vue?vue&type=template&id=13ddc5b8"
import script from "./ChecklistCleaningForm.vue?vue&type=script&lang=js"
export * from "./ChecklistCleaningForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports